var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParrot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 565,
    viewBox: "0 0 459 565",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.994 397.351C253.937 397.351 254.881 396.988 255.534 396.262C256.985 394.811 256.985 392.561 255.534 391.11L219.247 354.823C217.795 353.371 215.546 353.371 214.094 354.823C212.643 356.274 212.643 358.524 214.094 359.975L250.381 396.262C251.107 396.988 252.05 397.351 252.994 397.351Z",
    fill: "#F2726C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.997 397.352C255.029 397.352 256.626 395.755 256.626 393.723C256.626 388.135 261.126 383.635 266.714 383.635C272.302 383.635 276.802 388.135 276.802 393.723C276.802 395.755 278.398 397.352 280.43 397.352C282.462 397.352 284.059 395.755 284.059 393.723C284.059 384.143 276.294 376.378 266.714 376.378C257.134 376.378 249.369 384.143 249.369 393.723C249.369 395.755 250.965 397.352 252.997 397.352Z",
    fill: "#F2726C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.025 372.896V535.534C119.025 542.647 121.565 549.251 125.847 554.331C127.879 556.799 130.347 558.976 133.105 560.645C135.354 562.024 137.749 563.113 140.29 563.838C142.612 564.492 145.007 564.927 147.547 565C147.837 565 148.2 565 148.49 565C164.674 565 177.956 551.718 177.956 535.534V372.896C177.956 356.639 164.674 343.43 148.49 343.43C140.362 343.43 133.032 346.769 127.662 352.067C122.364 357.437 119.025 364.767 119.025 372.896Z",
    fill: "#222433"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.852 373.983V554.33C127.885 556.798 130.352 558.975 133.11 560.644V373.983H125.852Z",
    fill: "url(#paint0_linear_1193_339)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M140.287 373.984V563.838C142.61 564.491 145.005 564.926 147.545 564.999V373.984H140.287Z",
    fill: "url(#paint1_linear_1193_339)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.488 550.483C167.575 550.483 183.033 534.952 183.033 515.938C183.033 513.906 181.437 512.309 179.404 512.309C177.372 512.309 175.776 513.906 175.776 515.938C175.776 531.033 163.511 543.226 148.488 543.226C133.392 543.226 121.2 530.961 121.2 515.938C121.2 513.906 119.603 512.309 117.571 512.309C115.539 512.309 113.943 513.906 113.943 515.938C113.943 534.952 129.473 550.483 148.488 550.483Z",
    fill: "#32535D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.488 528.567C167.575 528.567 183.033 513.036 183.033 494.022C183.033 491.99 181.437 490.393 179.404 490.393C177.372 490.393 175.776 491.99 175.776 494.022C175.776 509.117 163.511 521.31 148.488 521.31C133.392 521.31 121.2 509.045 121.2 494.022C121.2 491.99 119.603 490.393 117.571 490.393C115.539 490.393 113.943 491.99 113.943 494.022C113.943 513.036 129.473 528.567 148.488 528.567Z",
    fill: "#32535D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.026 392.925C191.164 392.925 293.567 320.206 303.945 231.81C314.758 139.931 248.788 70.623 176.214 70.623V203.942C176.214 232.318 170.989 260.477 160.611 286.894L119.026 392.925Z",
    fill: "#222433"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.207 304.749C245.522 310.772 240.95 315.417 235.434 318.102C233.765 312.224 234.055 305.692 236.741 299.668C239.426 293.645 243.998 289 249.514 286.315C251.183 292.193 250.82 298.652 248.207 304.749Z",
    fill: "url(#paint2_linear_1193_339)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M213.588 304.749C210.903 310.772 206.331 315.417 200.815 318.102C199.146 312.224 199.436 305.692 202.122 299.668C204.807 293.645 209.379 289 214.895 286.315C216.564 292.193 216.274 298.652 213.588 304.749Z",
    fill: "url(#paint3_linear_1193_339)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.603 326.522C220.917 332.545 216.345 337.19 210.829 339.875C209.16 333.997 209.451 327.465 212.136 321.442C214.821 315.418 219.393 310.773 224.909 308.088C226.578 313.966 226.288 320.426 223.603 326.522Z",
    fill: "url(#paint4_linear_1193_339)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.031 326.518C106.031 330.074 106.103 333.63 106.394 337.186C106.902 345.532 107.99 353.878 109.66 362.152C109.95 363.531 110.24 364.91 110.53 366.289C111.111 368.756 119.239 392.706 119.022 392.923C148.269 370.353 170.622 338.347 180.855 299.883C181.436 297.633 182.016 295.384 182.524 293.061C184.701 283.554 186.153 273.684 186.806 263.596C188.548 238.34 185.427 212.213 176.21 189.715C173.96 191.457 171.711 193.272 169.461 195.159C143.189 217.149 121.417 245.888 111.909 281.377C109.732 289.505 108.136 297.778 107.192 306.125C106.394 312.947 106.031 319.696 106.031 326.518Z",
    fill: "#25386D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.031 326.518C106.031 330.074 106.103 333.63 106.394 337.186C106.902 345.532 107.99 353.878 109.66 362.152C109.95 363.531 110.24 364.91 110.53 366.289C111.111 368.756 119.239 392.706 119.022 392.923C148.269 370.353 170.622 338.347 180.855 299.883C181.436 297.633 182.016 295.384 182.524 293.061C184.701 283.554 186.153 273.684 186.806 263.596C188.548 238.34 185.427 212.213 176.21 189.715C173.96 191.457 171.711 193.272 169.461 195.159C143.189 217.149 121.417 245.888 111.909 281.377C109.732 289.505 108.136 297.778 107.192 306.125C106.394 312.947 106.031 319.696 106.031 326.518Z",
    fill: "#222433",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.193 306.127C134.481 283.774 155.31 252.93 165.107 216.207C165.688 213.957 166.269 211.708 166.777 209.385C167.865 204.74 168.736 199.951 169.462 195.088C143.19 217.078 121.418 245.817 111.911 281.306C109.733 289.507 108.137 297.781 107.193 306.127Z",
    fill: "url(#paint5_linear_1193_339)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M285.729 198.717C285.729 231.085 261.198 257.284 230.935 257.284C200.672 257.284 176.141 231.085 176.141 198.717V81.5096C237.176 81.5096 285.729 133.981 285.729 198.717Z",
    fill: "#F26C74"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.212 81.5096V170.486C176.212 195.088 193.121 214.974 214.023 214.974C234.924 214.974 251.834 195.016 251.834 170.486C251.834 122.949 220.482 84.1223 180.421 81.5822C178.969 81.5822 177.591 81.5096 176.212 81.5096Z",
    fill: "#F8EA8C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.075 131.731C188.774 131.731 180.424 123.38 180.424 113.079C180.424 102.778 188.774 94.4276 199.075 94.4276C209.376 94.4276 217.727 102.778 217.727 113.079C217.727 123.38 209.376 131.731 199.075 131.731Z",
    fill: "#43A3A8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M199.076 122.806C193.705 122.806 189.351 118.452 189.351 113.081C189.351 107.71 193.705 103.356 199.076 103.356C204.447 103.356 208.801 107.71 208.801 113.081C208.801 118.452 204.447 122.806 199.076 122.806Z",
    fill: "url(#paint6_linear_1193_339)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9794 115.909C25.6959 116.853 36.582 127.957 37.2352 141.673C48.4116 138.19 60.2412 136.375 72.5063 136.375H176.215V70.623H90.2144C79.9814 70.623 70.1113 72.2923 60.967 75.4855C40.2108 82.5978 22.7929 97.1126 11.9794 115.909Z",
    fill: "#F8EA8C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6309 160.833H176.215V136.375H72.5788C60.3138 136.375 48.4842 138.19 37.3078 141.673C37.3078 142.109 37.3078 142.544 37.3078 143.052C37.3078 149.801 34.7677 156.115 30.6309 160.833Z",
    fill: "#F26A6C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.052 70.623H176.212V136.375H157.052V70.623Z",
    fill: "url(#paint7_linear_1193_339)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M157.052 136.375H176.212V160.905H157.052V136.375Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00477982 160.833C11.0361 152.415 23.664 145.811 37.2354 141.601C36.5822 127.812 25.6961 116.781 11.9795 115.837C4.35923 129.119 0.00477982 144.504 0.00477982 160.833Z",
    fill: "#25316D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00477982 160.834H30.5585C33.6066 157.351 35.7839 153.069 36.7273 148.351C37.0902 146.61 37.2354 144.868 37.2354 142.981C37.2354 142.546 37.2354 142.11 37.2354 141.602C23.664 145.884 11.1086 152.416 0.00477982 160.834Z",
    fill: "#222433"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M122.435 136.375H157.053V70.623H118.299C120.113 78.1708 121.782 86.8071 122.726 96.3869C124.25 111.773 123.669 125.344 122.435 136.375Z",
    fill: "url(#paint8_linear_1193_339)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1193_339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 191,
    y: 106,
    width: 13,
    height: 13
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.841 118.233C194.514 118.233 191.817 115.537 191.817 112.21C191.817 108.883 194.514 106.186 197.841 106.186C201.168 106.186 203.865 108.883 203.865 112.21C203.865 115.537 201.168 118.233 197.841 118.233Z",
    fill: "url(#paint9_linear_1193_339)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1193_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.84 118.231C194.513 118.231 191.816 115.534 191.816 112.208C191.816 108.881 194.513 106.184 197.84 106.184C201.166 106.184 203.863 108.881 203.863 112.208C203.863 115.534 201.166 118.231 197.84 118.231Z",
    fill: "url(#paint10_linear_1193_339)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M200.452 397.352C201.396 397.352 202.339 396.989 202.992 396.263C204.444 394.812 204.444 392.562 202.992 391.11L178.825 366.943C177.374 365.492 175.124 365.492 173.672 366.943C172.221 368.395 172.221 370.644 173.672 372.096L197.84 396.263C198.565 396.989 199.509 397.352 200.452 397.352Z",
    fill: "#F2726C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M200.451 397.353C202.483 397.353 204.08 395.756 204.08 393.724C204.08 388.136 208.58 383.636 214.168 383.636C219.756 383.636 224.256 388.136 224.256 393.724C224.256 395.756 225.852 397.353 227.884 397.353C229.917 397.353 231.513 395.756 231.513 393.724C231.513 384.144 223.748 376.379 214.168 376.379C204.588 376.379 196.823 384.144 196.823 393.724C196.823 395.756 198.419 397.353 200.451 397.353Z",
    fill: "#F2726C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7847 401.998H351.951C354.927 401.998 357.394 399.531 357.394 396.555C357.394 393.579 354.927 391.112 351.951 391.112H42.7847C39.8092 391.112 37.3417 393.579 37.3417 396.555C37.3417 399.531 39.8092 401.998 42.7847 401.998Z",
    fill: "#A86E58"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M227.812 397.353C229.844 397.353 231.44 395.757 231.44 393.725C231.44 384.145 223.675 376.379 214.095 376.379C212.063 376.379 210.466 377.976 210.466 380.008C210.466 382.04 212.063 383.637 214.095 383.637C219.683 383.637 224.183 388.136 224.183 393.725C224.183 395.757 225.852 397.353 227.812 397.353Z",
    fill: "#F2726C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M280.353 397.356C282.385 397.356 283.981 395.76 283.981 393.727C283.981 384.148 276.216 376.382 266.636 376.382C264.604 376.382 263.007 377.979 263.007 380.011C263.007 382.043 264.604 383.64 266.636 383.64C272.224 383.64 276.724 388.139 276.724 393.727C276.724 395.76 278.393 397.356 280.353 397.356Z",
    fill: "#F2726C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M265.118 48.5843C265.118 48.5843 279.819 42.5906 284.237 30.276C288.655 17.9614 281.118 3.98922 281.118 3.98922C281.118 3.98922 266.418 9.98295 261.999 22.2975C257.581 34.6121 265.118 48.5843 265.118 48.5843Z",
    fill: "#F2726C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M357.611 229.266C357.611 229.266 369.491 241.798 384.019 241.679C398.546 241.56 410.22 228.835 410.22 228.835C410.22 228.835 398.34 216.303 383.812 216.422C369.284 216.541 357.611 229.266 357.611 229.266Z",
    fill: "#FAA881"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M316.549 383.779C316.549 383.779 332.237 386.255 343.037 378.051C353.836 369.847 355.656 354.069 355.656 354.069C355.656 354.069 339.968 351.592 329.168 359.796C318.369 368 316.549 383.779 316.549 383.779Z",
    fill: "#7675FD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M277.968 406.708C277.968 406.708 275.39 417.915 280.806 425.931C286.222 433.948 297.582 435.739 297.582 435.739C297.582 435.739 300.16 424.532 294.744 416.516C289.328 408.499 277.968 406.708 277.968 406.708Z",
    fill: "#43A3A8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M334.346 99.0473C334.346 99.0473 372.297 106.809 402.947 88.8278C433.597 70.8467 445.339 33.932 445.339 33.932C445.339 33.932 407.387 26.1703 376.737 44.1514C346.088 62.1325 334.346 99.0473 334.346 99.0473Z",
    fill: "#7675FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1193_339",
    x1: 129.467,
    y1: 555.917,
    x2: 129.467,
    y2: 394.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24C667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1193_339",
    x1: 143.916,
    y1: 601.15,
    x2: 143.916,
    y2: 420.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24C667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1193_339",
    x1: 232.716,
    y1: 324.123,
    x2: 246.01,
    y2: 294.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5313,
    stopColor: "#244C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24236D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1193_339",
    x1: 198.105,
    y1: 324.123,
    x2: 211.399,
    y2: 294.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5313,
    stopColor: "#244C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24236D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1193_339",
    x1: 208.175,
    y1: 345.879,
    x2: 221.469,
    y2: 315.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5313,
    stopColor: "#244C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24236D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1193_339",
    x1: 179.176,
    y1: 164.387,
    x2: 122.568,
    y2: 282.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7675FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1193_339",
    x1: 204.36,
    y1: 120.18,
    x2: 193.353,
    y2: 105.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24236D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1193_339",
    x1: 166.621,
    y1: 133.424,
    x2: 166.621,
    y2: 73.9053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#244C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1193_339",
    x1: 137.647,
    y1: 134.875,
    x2: 137.647,
    y2: 79.0651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15665"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1193_339",
    x1: 199.614,
    y1: 117.007,
    x2: 195.982,
    y2: 107.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00386639
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1193_339",
    x1: 199.613,
    y1: 117.004,
    x2: 195.98,
    y2: 107.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00386639
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "#C6C6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParrot);
export default __webpack_public_path__ + "static/media/Parrot.56aecec0856b9bc983a99df8d42918f4.svg";
export { ForwardRef as ReactComponent };